import { overlayOpenListener } from '../Listeners/overlayOpenListener';
import { showOverlay } from '../Overlay/showOverlay';
const STEPS = 5;

export const ladderStatus = (index:number = 0) => {
    // @ts-ignore
    const pushLabelSuccess = window.push_label_success as HTMLElement;
    // @ts-ignore
    const pushLabelWon = window.push_label_won as HTMLElement;
    if (index > 0) {
        // @ts-ignore
        (window.push_label_start as HTMLElement).hidden = true;
        // @ts-ignore
        (window.push_label_retry as HTMLElement).hidden = true;
        pushLabelSuccess.hidden = false;
        pushLabelSuccess.innerText = pushLabelSuccess.innerText.replace(/\d+/, (STEPS - index).toString());
    }   else if (index === 0) {
        pushLabelSuccess.hidden = true;
        pushLabelWon.hidden = false;

        setTimeout(() => {
            showOverlay();
            overlayOpenListener();
        }, 1000);
    } 
}